<template>
  <div class="sift-sort-container">
    <ul class="sift-sort-list">
      <li class="sift-sort-item pointer" v-for="(item,index) in ['综合排序','销量','价格']" :key="index"
        @click="siftSortClick(index)">
        <span
          :class="'sift-sort-item-name ' + (currentSiftIndex == index * 2 + 1 || currentSiftIndex == index * 2 ? 'active' : '')">{{item}}</span>
        <img class="sift-sort-item-arrow"
          :src="('icon_sift_' + (index * 2 + 1 == currentSiftIndex ? 'top' : index * 2 == currentSiftIndex ? 'bottom' : 'normal') + '.png') | imagePath">
      </li>
    </ul>
    <el-checkbox class="sift-stock" v-model="checked" @change="shiftStockClick">仅查询有库存</el-checkbox>
    <div style="flex: 1;"></div>
    <ul class="sift-arrange-list">
      <li class="sift-arrange-item pointer" v-for="(item,index) in arrangeArray" :key="index"
        @click="arrangeClick(index)">
        <img class="sift-arrange-item-icon"
          :src="(index == currentArrangeIndex ? item.iconPressed : item.icon) | imagePath">
        <span :class="'sift-arrange-item-name ' + (index == currentArrangeIndex ? 'active' : '')">{{item.name}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        currentSiftIndex: 0,
        arrangeArray: [{
            name: '大图',
            icon: 'icon_goods_show_normal.png',
            iconPressed: 'icon_goods_show_ressed.png'
          },
          {
            name: '列表',
            icon: 'icon_goods_show_list_normal.png',
            iconPressed: 'icon_goods_show_list_ressed.png'
          }
        ],
        currentArrangeIndex: 0, //0大图 1列表
        checked: false
      }
    },
    methods: {
      siftSortClick(index) {
        this.currentSiftIndex =  this.currentSiftIndex == index * 2 ? index * 2 + 1 : index * 2;
        this.$emit('change', {
          type: 'sort',
          index: this.currentSiftIndex
        });
      },
      arrangeClick(index) {
        if (index == this.currentArrangeIndex) return;
        this.currentArrangeIndex = index;
        this.$emit('change', {
          type: 'arrange',
          index: index
        });
      },
      shiftStockClick(v){
        this.$emit('change', {
          type: 'stock',
          value: v ? 1 : 0
        });
      }
    }
  }
</script>

<style>
  .sift-sort-container {
    position: relative;
    height: 60px;
    padding: 0 20px;
    background-color: #F5F5F5;
    display: flex;
    align-items: center;
  }

  .sift-sort-list {
    display: flex;
    align-items: center;
  }

  .sift-sort-item {
    display: flex;
    align-items: center;
    margin-right: 100px;
  }

  .sift-sort-item-name {
    font-size: 14px;
    color: #333333;
  }

  .sift-sort-item-name.active {
    color: #E60012;
  }

  .sift-sort-item-arrow {
    width: 14px;
    height: 20px;
    margin-left: 13px;
  }

  .sift-arrange-list {
    display: flex;
    align-items: center;
  }

  .sift-arrange-item {
    display: flex;
    align-items: center;
    margin-right: 18px;
  }

  .sift-arrange-item-icon {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }

  .sift-arrange-item-name {
    font-size: 14px;
    color: #333333;
  }
  .sift-stock .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #E60012 !important; 
  }
  .sift-stock .el-checkbox__input.is-checked .el-checkbox__inner{
    background: #E60012 !important; 
    border-color: #E60012 !important; 
  }
</style>



// WEBPACK FOOTER //
// src/components/SiftSort/index.vue